// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"5b10655b","168":"7339ffa0","441":"e7b707e2","551":"fbdd0a42","581":"6392fdec"}[chunkId] + ".css";
};